// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManifestUpload {
  height: 100%;
}
.ManifestUpload .manifest-upload-card {
  height: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.ManifestUpload .manifest-upload-card .card-body {
  padding: 24px;
}
.ManifestUpload .date-section {
  margin-bottom: 24px;
}
.ManifestUpload .date-section .date-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 768px) {
  .ManifestUpload .date-section .date-row {
    grid-template-columns: 1fr;
  }
}
.ManifestUpload .date-section .date-group .date-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}
.ManifestUpload .date-section .date-group .date-label .calendar-icon {
  font-size: 14px;
  color: #666;
}
.ManifestUpload .date-section .date-group .date-input {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
}
.ManifestUpload .date-section .date-group .date-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.ManifestUpload .date-section .date-group .date-input::placeholder {
  color: #999;
}
.ManifestUpload .locations-section {
  margin-bottom: 24px;
}
.ManifestUpload .locations-section .locations-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
}
.ManifestUpload .locations-section .locations-header .location-icon {
  font-size: 14px;
  color: #666;
}
.ManifestUpload .locations-section .location-group {
  margin-bottom: 16px;
}
.ManifestUpload .locations-section .location-group .location-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}
.ManifestUpload .locations-section .location-group .location-input-row {
  display: flex;
  gap: 8px;
  align-items: stretch;
}
.ManifestUpload .locations-section .location-group .location-input-row .location-input-group {
  flex: 1;
}
.ManifestUpload .locations-section .location-group .location-input-row .location-input-group:focus-within {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  border-radius: 4px;
}
.ManifestUpload .locations-section .location-group .location-input-row .location-input-group .location-input {
  border: 1px solid #d0d0d0;
  border-right: none;
  border-radius: 4px 0 0 4px;
  padding: 8px 12px;
  font-size: 14px;
}
.ManifestUpload .locations-section .location-group .location-input-row .location-input-group .location-input:focus {
  border-color: #007bff;
  border-right: none;
  box-shadow: none;
  outline: none;
}
.ManifestUpload .locations-section .location-group .location-input-row .location-input-group .location-input::placeholder {
  color: #999;
}
.ManifestUpload .locations-section .location-group .location-input-row .location-input-group .search-btn {
  border-top: 1px solid #d0d0d0;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
  border-left: none;
  border-radius: 0 4px 4px 0;
  background: transparent;
  color: #666;
  padding: 8px 12px;
  font-size: 14px;
  cursor: text;
  pointer-events: auto;
}
.ManifestUpload .locations-section .location-group .location-input-row .location-input-group .search-btn:hover, .ManifestUpload .locations-section .location-group .location-input-row .location-input-group .search-btn:focus, .ManifestUpload .locations-section .location-group .location-input-row .location-input-group .search-btn:active, .ManifestUpload .locations-section .location-group .location-input-row .location-input-group .search-btn:focus-visible {
  background: transparent !important;
  border-top: 1px solid #d0d0d0 !important;
  border-right: 1px solid #d0d0d0 !important;
  border-bottom: 1px solid #d0d0d0 !important;
  border-left: none !important;
  color: #666 !important;
  box-shadow: none !important;
  outline: none !important;
}
.ManifestUpload .locations-section .location-group .location-input-row .location-input-group .search-btn .search-small-icon {
  font-size: 12px;
  color: #666;
}
.ManifestUpload .locations-section .location-group .location-input-row .location-input-group:focus-within .location-input {
  border-color: #007bff;
}
.ManifestUpload .locations-section .location-group .location-input-row .location-input-group:focus-within .search-btn {
  border-color: #007bff;
}
.ManifestUpload .locations-section .location-group .location-input-row .location-input-group:focus-within .search-btn:hover, .ManifestUpload .locations-section .location-group .location-input-row .location-input-group:focus-within .search-btn:focus, .ManifestUpload .locations-section .location-group .location-input-row .location-input-group:focus-within .search-btn:active, .ManifestUpload .locations-section .location-group .location-input-row .location-input-group:focus-within .search-btn:focus-visible {
  background: transparent !important;
  border-top: 1px solid #007bff !important;
  border-right: 1px solid #007bff !important;
  border-bottom: 1px solid #007bff !important;
  border-left: none !important;
  color: #666 !important;
  box-shadow: none !important;
  outline: none !important;
}
.ManifestUpload .locations-section .location-group .location-input-row .add-btn-separate {
  border: 1px solid #d0d0d0;
  background: #f8f9fa;
  color: #666;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  min-width: 40px;
}
.ManifestUpload .locations-section .location-group .location-input-row .add-btn-separate:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}
.ManifestUpload .submit-section {
  text-align: center;
}
.ManifestUpload .submit-section .create-query-btn {
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  justify-content: center;
}
.ManifestUpload .submit-section .create-query-btn .search-icon-btn {
  font-size: 14px;
  color: white;
}
.ManifestUpload .icon-container {
  background-color: rgba(var(--bs-gray-subtle-rgb), 0.4);
}
.ManifestUpload.status-ready .icon-container, .ManifestUpload.status-success .icon-container {
  background-color: var(--bs-success-bg-subtle);
  border: 2px solid var(--bs-success);
  color: var(--bs-success);
}
.ManifestUpload.status-success .card-header {
  background-color: var(--bs-success-bg-subtle);
}
.ManifestUpload.status-error .card-header {
  background-color: var(--bs-danger-bg-subtle);
}
.ManifestUpload.status-error .icon-container {
  background-color: var(--bs-danger-bg-subtle);
  border: 2px solid var(--bs-danger);
  color: var(--bs-danger);
}
.ManifestUpload .File {
  border: 1px solid var(--bs-cyan);
}
.ManifestUpload .File .icon-container {
  background-color: var(--bs-cyan-bg-subtle);
  border: none;
}
.ManifestUpload .File .icon-container .sv-document {
  color: var(--bs-cyan);
}
.ManifestUpload .File.status-success {
  border-color: var(--bs-success-bg-subtle);
}
.ManifestUpload .File.status-success .icon-container {
  background-color: var(--bs-success-bg-subtle);
}
.ManifestUpload .File.status-success .icon-container .sv-document {
  color: var(--bs-success);
}
.ManifestUpload .File.status-danger {
  border-color: var(--bs-danger-bg-subtle);
}
.ManifestUpload .File.status-danger .icon-container {
  background-color: var(--bs-danger-bg-subtle);
}
.ManifestUpload .File.status-danger .icon-container .sv-document {
  color: var(--bs-danger);
}
.ManifestUpload .FileUpload label {
  border: none !important;
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/ManifestUpload/styles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AAAE;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;AAEJ;AAAI;EACE,aAAA;AAEN;AAEE;EACE,mBAAA;AAAJ;AAEI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAAN;AAEM;EALF;IAMI,0BAAA;EACN;AACF;AAGM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AADR;AAGQ;EACE,eAAA;EACA,WAAA;AADV;AAKM;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAHR;AAKQ;EACE,qBAAA;EACA,gDAAA;AAHV;AAMQ;EACE,WAAA;AAJV;AAUE;EACE,mBAAA;AARJ;AAUI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AARN;AAUM;EACE,eAAA;EACA,WAAA;AARR;AAYI;EACE,mBAAA;AAVN;AAYM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAVR;AAaM;EACE,aAAA;EACA,QAAA;EACA,oBAAA;AAXR;AAaQ;EACE,OAAA;AAXV;AAaU;EACE,gDAAA;EACA,kBAAA;AAXZ;AAcU;EACE,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;AAZZ;AAcY;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAZd;AAeY;EACE,WAAA;AAbd;AAiBU;EACE,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,iBAAA;EACA,0BAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;AAfZ;AAiBY;EAIE,kCAAA;EACA,wCAAA;EACA,0CAAA;EACA,2CAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;AAlBd;AAqBY;EACE,eAAA;EACA,WAAA;AAnBd;AAuBU;EACE,qBAAA;AArBZ;AAwBU;EACE,qBAAA;AAtBZ;AAwBY;EAIE,kCAAA;EACA,wCAAA;EACA,0CAAA;EACA,2CAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;AAzBd;AA8BQ;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AA5BV;AA8BU;EACE,mBAAA;EACA,qBAAA;AA5BZ;AAmCE;EACE,kBAAA;AAjCJ;AAmCI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;AAjCN;AAmCM;EACE,eAAA;EACA,YAAA;AAjCR;AAqCE;EACE,sDAAA;AAnCJ;AAwCI;EACE,6CAAA;EACA,mCAAA;EACA,wBAAA;AAtCN;AA0CI;EACE,6CAAA;AAxCN;AA4CI;EACE,4CAAA;AA1CN;AA4CI;EACE,4CAAA;EACA,kCAAA;EACA,uBAAA;AA1CN;AA8CE;EACE,gCAAA;AA5CJ;AA6CI;EACE,0CAAA;EACA,YAAA;AA3CN;AA4CM;EACE,qBAAA;AA1CR;AA8CI;EACE,yCAAA;AA5CN;AA6CM;EACE,6CAAA;AA3CR;AA4CQ;EACE,wBAAA;AA1CV;AA8CI;EACE,wCAAA;AA5CN;AA6CM;EACE,4CAAA;AA3CR;AA4CQ;EACE,uBAAA;AA1CV;AAiDI;EACE,uBAAA;EACA,qBAAA;AA/CN","sourcesContent":[".ManifestUpload {\n  height: 100%;\n  .manifest-upload-card {\n    height: 100%;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n    .card-body {\n      padding: 24px;\n    }\n  }\n\n  .date-section {\n    margin-bottom: 24px;\n\n    .date-row {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 16px;\n\n      @media (max-width: 768px) {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    .date-group {\n      .date-label {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        font-size: 14px;\n        font-weight: 500;\n        color: #333;\n        margin-bottom: 8px;\n\n        .calendar-icon {\n          font-size: 14px;\n          color: #666;\n        }\n      }\n\n      .date-input {\n        border: 1px solid #d0d0d0;\n        border-radius: 4px;\n        padding: 8px 12px;\n        font-size: 14px;\n\n        &:focus {\n          border-color: #007bff;\n          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n        }\n\n        &::placeholder {\n          color: #999;\n        }\n      }\n    }\n  }\n\n  .locations-section {\n    margin-bottom: 24px;\n\n    .locations-header {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      font-size: 14px;\n      font-weight: 500;\n      color: #333;\n      margin-bottom: 16px;\n\n      .location-icon {\n        font-size: 14px;\n        color: #666;\n      }\n    }\n\n    .location-group {\n      margin-bottom: 16px;\n\n      .location-label {\n        font-size: 14px;\n        font-weight: 500;\n        color: #333;\n        margin-bottom: 8px;\n      }\n\n      .location-input-row {\n        display: flex;\n        gap: 8px;\n        align-items: stretch;\n\n        .location-input-group {\n          flex: 1;\n\n          &:focus-within {\n            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n            border-radius: 4px;\n          }\n\n          .location-input {\n            border: 1px solid #d0d0d0;\n            border-right: none;\n            border-radius: 4px 0 0 4px;\n            padding: 8px 12px;\n            font-size: 14px;\n\n            &:focus {\n              border-color: #007bff;\n              border-right: none;\n              box-shadow: none;\n              outline: none;\n            }\n\n            &::placeholder {\n              color: #999;\n            }\n          }\n\n          .search-btn {\n            border-top: 1px solid #d0d0d0;\n            border-right: 1px solid #d0d0d0;\n            border-bottom: 1px solid #d0d0d0;\n            border-left: none;\n            border-radius: 0 4px 4px 0;\n            background: transparent;\n            color: #666;\n            padding: 8px 12px;\n            font-size: 14px;\n            cursor: text;\n            pointer-events: auto;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:focus-visible {\n              background: transparent !important;\n              border-top: 1px solid #d0d0d0 !important;\n              border-right: 1px solid #d0d0d0 !important;\n              border-bottom: 1px solid #d0d0d0 !important;\n              border-left: none !important;\n              color: #666 !important;\n              box-shadow: none !important;\n              outline: none !important;\n            }\n\n            .search-small-icon {\n              font-size: 12px;\n              color: #666;\n            }\n          }\n\n          &:focus-within .location-input {\n            border-color: #007bff;\n          }\n\n          &:focus-within .search-btn {\n            border-color: #007bff;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:focus-visible {\n              background: transparent !important;\n              border-top: 1px solid #007bff !important;\n              border-right: 1px solid #007bff !important;\n              border-bottom: 1px solid #007bff !important;\n              border-left: none !important;\n              color: #666 !important;\n              box-shadow: none !important;\n              outline: none !important;\n            }\n          }\n        }\n\n        .add-btn-separate {\n          border: 1px solid #d0d0d0;\n          background: #f8f9fa;\n          color: #666;\n          padding: 8px 12px;\n          font-size: 14px;\n          font-weight: 600;\n          border-radius: 4px;\n          min-width: 40px;\n\n          &:hover {\n            background: #e9ecef;\n            border-color: #adb5bd;\n          }\n        }\n      }\n    }\n  }\n\n  .submit-section {\n    text-align: center;\n\n    .create-query-btn {\n      padding: 12px 24px;\n      font-size: 14px;\n      font-weight: 500;\n      border-radius: 4px;\n      display: inline-flex;\n      align-items: center;\n      gap: 8px;\n      width: 100%;\n      justify-content: center;\n\n      .search-icon-btn {\n        font-size: 14px;\n        color: white;\n      }\n    }\n  }\n  .icon-container {\n    background-color: rgba(var(--bs-gray-subtle-rgb), 0.4);\n  }\n\n  &.status-ready,\n  &.status-success {\n    .icon-container {\n      background-color: var(--bs-success-bg-subtle);\n      border: 2px solid var(--bs-success);\n      color: var(--bs-success);\n    }\n  }\n  &.status-success {\n    .card-header {\n      background-color: var(--bs-success-bg-subtle);\n    }\n  }\n  &.status-error {\n    .card-header {\n      background-color: var(--bs-danger-bg-subtle);\n    }\n    .icon-container {\n      background-color: var(--bs-danger-bg-subtle);\n      border: 2px solid var(--bs-danger);\n      color: var(--bs-danger);\n    }\n  }\n\n  .File {\n    border: 1px solid var(--bs-cyan);\n    .icon-container {\n      background-color: var(--bs-cyan-bg-subtle);\n      border: none;\n      .sv-document {\n        color: var(--bs-cyan);\n      }\n    }\n\n    &.status-success {\n      border-color: var(--bs-success-bg-subtle);\n      .icon-container {\n        background-color: var(--bs-success-bg-subtle);\n        .sv-document {\n          color: var(--bs-success);\n        }\n      }\n    }\n    &.status-danger {\n      border-color: var(--bs-danger-bg-subtle);\n      .icon-container {\n        background-color: var(--bs-danger-bg-subtle);\n        .sv-document {\n          color: var(--bs-danger);\n        }\n      }\n    }\n  }\n\n  .FileUpload {\n    label {\n      border: none !important;\n      padding: 0 !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
